import {
  Companion_instance1a8y12exr3m74 as Companion_instance,
  PasswordSecret36s6jaq76xka2 as PasswordSecret,
} from './AuthSecrets.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function preparePasswordSecretFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PasswordSecret__id_getInstance(), PasswordSecret_subjectType_getInstance(), PasswordSecret_subjectId_getInstance(), PasswordSecret_hash_getInstance(), PasswordSecret_hint_getInstance(), PasswordSecret_establishedAt_getInstance(), PasswordSecret_lastUsedAt_getInstance(), PasswordSecret_expiresAt_getInstance(), PasswordSecret_disabledAt_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function PasswordSecret__id$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function PasswordSecret__id$_get_name_$ref_1oljn1() {
  return (p0) => p0.i20();
}
function PasswordSecret__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret__id$_get_serializer_$ref_s3gj46() {
  return (p0) => p0.h2j();
}
function PasswordSecret__id$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function PasswordSecret__id$_get_annotations_$ref_2i6qda() {
  return (p0) => p0.bz();
}
var PasswordSecret__idClass;
function PasswordSecret__id() {
  if (PasswordSecret__idClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret__id_instance = this;
        var tmp = this;
        tmp.b2u_1 = lazy(PasswordSecret__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c2u_1 = lazy(PasswordSecret__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d2u_1 = lazy(PasswordSecret__id$annotations$delegate$lambda);
        this.e2u_1 = Companion_getInstance().k2p();
        this.f2u_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.b2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret__id$_get_name_$ref_1oljn1(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.h2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      q2u(receiver, value) {
        return receiver.r2u(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.q2u(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret__id$_get_serializer_$ref_s3gj46(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret__id$_get_annotations_$ref_2i6qda(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret__id', VOID, VOID, [SerializableProperty()]);
    PasswordSecret__idClass = $;
  }
  return PasswordSecret__idClass;
}
var PasswordSecret__id_instance;
function PasswordSecret__id_getInstance() {
  if (PasswordSecret__id_instance === VOID)
    new (PasswordSecret__id())();
  return PasswordSecret__id_instance;
}
function PasswordSecret_subjectType$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function PasswordSecret_subjectType$_get_name_$ref_50ltgh() {
  return (p0) => p0.i20();
}
function PasswordSecret_subjectType$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_subjectType$_get_serializer_$ref_mr9ym2() {
  return (p0) => p0.h2j();
}
function PasswordSecret_subjectType$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function PasswordSecret_subjectType$_get_annotations_$ref_kx8t9y() {
  return (p0) => p0.bz();
}
var PasswordSecret_subjectTypeClass;
function PasswordSecret_subjectType() {
  if (PasswordSecret_subjectTypeClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_subjectType_instance = this;
        var tmp = this;
        tmp.s2u_1 = lazy(PasswordSecret_subjectType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t2u_1 = lazy(PasswordSecret_subjectType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u2u_1 = lazy(PasswordSecret_subjectType$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.s2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_subjectType$_get_name_$ref_50ltgh(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.i2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      v2u(receiver, value) {
        return receiver.r2u(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.v2u(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_subjectType$_get_serializer_$ref_mr9ym2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_subjectType$_get_annotations_$ref_kx8t9y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_subjectType', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_subjectTypeClass = $;
  }
  return PasswordSecret_subjectTypeClass;
}
var PasswordSecret_subjectType_instance;
function PasswordSecret_subjectType_getInstance() {
  if (PasswordSecret_subjectType_instance === VOID)
    new (PasswordSecret_subjectType())();
  return PasswordSecret_subjectType_instance;
}
function PasswordSecret_subjectId$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(2);
}
function PasswordSecret_subjectId$_get_name_$ref_hoh3z4() {
  return (p0) => p0.i20();
}
function PasswordSecret_subjectId$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_subjectId$_get_serializer_$ref_dv49q1() {
  return (p0) => p0.h2j();
}
function PasswordSecret_subjectId$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(2);
}
function PasswordSecret_subjectId$_get_annotations_$ref_chp0yd() {
  return (p0) => p0.bz();
}
var PasswordSecret_subjectIdClass;
function PasswordSecret_subjectId() {
  if (PasswordSecret_subjectIdClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_subjectId_instance = this;
        var tmp = this;
        tmp.w2u_1 = lazy(PasswordSecret_subjectId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x2u_1 = lazy(PasswordSecret_subjectId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y2u_1 = lazy(PasswordSecret_subjectId$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_subjectId$_get_name_$ref_hoh3z4(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.j2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      v2u(receiver, value) {
        return receiver.r2u(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.v2u(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_subjectId$_get_serializer_$ref_dv49q1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_subjectId$_get_annotations_$ref_chp0yd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_subjectId', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_subjectIdClass = $;
  }
  return PasswordSecret_subjectIdClass;
}
var PasswordSecret_subjectId_instance;
function PasswordSecret_subjectId_getInstance() {
  if (PasswordSecret_subjectId_instance === VOID)
    new (PasswordSecret_subjectId())();
  return PasswordSecret_subjectId_instance;
}
function PasswordSecret_hash$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(3);
}
function PasswordSecret_hash$_get_name_$ref_pq8kmp() {
  return (p0) => p0.i20();
}
function PasswordSecret_hash$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_hash$_get_serializer_$ref_miwa5y() {
  return (p0) => p0.h2j();
}
function PasswordSecret_hash$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(3);
}
function PasswordSecret_hash$_get_annotations_$ref_42d9vq() {
  return (p0) => p0.bz();
}
var PasswordSecret_hashClass;
function PasswordSecret_hash() {
  if (PasswordSecret_hashClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_hash_instance = this;
        var tmp = this;
        tmp.z2u_1 = lazy(PasswordSecret_hash$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a2v_1 = lazy(PasswordSecret_hash$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b2v_1 = lazy(PasswordSecret_hash$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.z2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_hash$_get_name_$ref_pq8kmp(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.k2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      v2u(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.v2u(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_hash$_get_serializer_$ref_miwa5y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_hash$_get_annotations_$ref_42d9vq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_hash', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_hashClass = $;
  }
  return PasswordSecret_hashClass;
}
var PasswordSecret_hash_instance;
function PasswordSecret_hash_getInstance() {
  if (PasswordSecret_hash_instance === VOID)
    new (PasswordSecret_hash())();
  return PasswordSecret_hash_instance;
}
function PasswordSecret_hint$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(4);
}
function PasswordSecret_hint$_get_name_$ref_zahtm0() {
  return (p0) => p0.i20();
}
function PasswordSecret_hint$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_hint$_get_serializer_$ref_tgh41d() {
  return (p0) => p0.h2j();
}
function PasswordSecret_hint$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(4);
}
function PasswordSecret_hint$_get_annotations_$ref_qbfb0t() {
  return (p0) => p0.bz();
}
var PasswordSecret_hintClass;
function PasswordSecret_hint() {
  if (PasswordSecret_hintClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_hint_instance = this;
        var tmp = this;
        tmp.c2v_1 = lazy(PasswordSecret_hint$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d2v_1 = lazy(PasswordSecret_hint$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e2v_1 = lazy(PasswordSecret_hint$annotations$delegate$lambda);
        this.f2v_1 = null;
        this.g2v_1 = 'null';
      }
      i20() {
        var tmp0 = this.c2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_hint$_get_name_$ref_zahtm0(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.l2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      h2v(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.h2v(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_hint$_get_serializer_$ref_tgh41d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_hint$_get_annotations_$ref_qbfb0t(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_hint', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_hintClass = $;
  }
  return PasswordSecret_hintClass;
}
var PasswordSecret_hint_instance;
function PasswordSecret_hint_getInstance() {
  if (PasswordSecret_hint_instance === VOID)
    new (PasswordSecret_hint())();
  return PasswordSecret_hint_instance;
}
function PasswordSecret_establishedAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(5);
}
function PasswordSecret_establishedAt$_get_name_$ref_xkzjh8() {
  return (p0) => p0.i20();
}
function PasswordSecret_establishedAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_establishedAt$_get_serializer_$ref_matq2d() {
  return (p0) => p0.h2j();
}
function PasswordSecret_establishedAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(5);
}
function PasswordSecret_establishedAt$_get_annotations_$ref_z3868h() {
  return (p0) => p0.bz();
}
var PasswordSecret_establishedAtClass;
function PasswordSecret_establishedAt() {
  if (PasswordSecret_establishedAtClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_establishedAt_instance = this;
        var tmp = this;
        tmp.i2v_1 = lazy(PasswordSecret_establishedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j2v_1 = lazy(PasswordSecret_establishedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k2v_1 = lazy(PasswordSecret_establishedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.l2v_1 = get_default(Companion_instance_0).b1m();
        this.m2v_1 = 'now()';
      }
      i20() {
        var tmp0 = this.i2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_establishedAt$_get_name_$ref_xkzjh8(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.m2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      n2v(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.n2v(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_establishedAt$_get_serializer_$ref_matq2d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_establishedAt$_get_annotations_$ref_z3868h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_establishedAt', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_establishedAtClass = $;
  }
  return PasswordSecret_establishedAtClass;
}
var PasswordSecret_establishedAt_instance;
function PasswordSecret_establishedAt_getInstance() {
  if (PasswordSecret_establishedAt_instance === VOID)
    new (PasswordSecret_establishedAt())();
  return PasswordSecret_establishedAt_instance;
}
function PasswordSecret_lastUsedAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(6);
}
function PasswordSecret_lastUsedAt$_get_name_$ref_n3awl5() {
  return (p0) => p0.i20();
}
function PasswordSecret_lastUsedAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_lastUsedAt$_get_serializer_$ref_swhzma() {
  return (p0) => p0.h2j();
}
function PasswordSecret_lastUsedAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(6);
}
function PasswordSecret_lastUsedAt$_get_annotations_$ref_rifxyq() {
  return (p0) => p0.bz();
}
var PasswordSecret_lastUsedAtClass;
function PasswordSecret_lastUsedAt() {
  if (PasswordSecret_lastUsedAtClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_lastUsedAt_instance = this;
        var tmp = this;
        tmp.o2v_1 = lazy(PasswordSecret_lastUsedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p2v_1 = lazy(PasswordSecret_lastUsedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q2v_1 = lazy(PasswordSecret_lastUsedAt$annotations$delegate$lambda);
        this.r2v_1 = null;
        this.s2v_1 = 'null';
      }
      i20() {
        var tmp0 = this.o2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_lastUsedAt$_get_name_$ref_n3awl5(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.n2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      t2v(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.t2v(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_lastUsedAt$_get_serializer_$ref_swhzma(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_lastUsedAt$_get_annotations_$ref_rifxyq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_lastUsedAt', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_lastUsedAtClass = $;
  }
  return PasswordSecret_lastUsedAtClass;
}
var PasswordSecret_lastUsedAt_instance;
function PasswordSecret_lastUsedAt_getInstance() {
  if (PasswordSecret_lastUsedAt_instance === VOID)
    new (PasswordSecret_lastUsedAt())();
  return PasswordSecret_lastUsedAt_instance;
}
function PasswordSecret_expiresAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(7);
}
function PasswordSecret_expiresAt$_get_name_$ref_ckaqio() {
  return (p0) => p0.i20();
}
function PasswordSecret_expiresAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_expiresAt$_get_serializer_$ref_ctka93() {
  return (p0) => p0.h2j();
}
function PasswordSecret_expiresAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(7);
}
function PasswordSecret_expiresAt$_get_annotations_$ref_cmifij() {
  return (p0) => p0.bz();
}
var PasswordSecret_expiresAtClass;
function PasswordSecret_expiresAt() {
  if (PasswordSecret_expiresAtClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_expiresAt_instance = this;
        var tmp = this;
        tmp.u2v_1 = lazy(PasswordSecret_expiresAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v2v_1 = lazy(PasswordSecret_expiresAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w2v_1 = lazy(PasswordSecret_expiresAt$annotations$delegate$lambda);
        this.x2v_1 = null;
        this.y2v_1 = 'null';
      }
      i20() {
        var tmp0 = this.u2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_expiresAt$_get_name_$ref_ckaqio(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.o2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      t2v(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.t2v(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_expiresAt$_get_serializer_$ref_ctka93(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_expiresAt$_get_annotations_$ref_cmifij(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_expiresAt', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_expiresAtClass = $;
  }
  return PasswordSecret_expiresAtClass;
}
var PasswordSecret_expiresAt_instance;
function PasswordSecret_expiresAt_getInstance() {
  if (PasswordSecret_expiresAt_instance === VOID)
    new (PasswordSecret_expiresAt())();
  return PasswordSecret_expiresAt_instance;
}
function PasswordSecret_disabledAt$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(8);
}
function PasswordSecret_disabledAt$_get_name_$ref_rsoads() {
  return (p0) => p0.i20();
}
function PasswordSecret_disabledAt$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PasswordSecret_disabledAt$_get_serializer_$ref_gxthg7() {
  return (p0) => p0.h2j();
}
function PasswordSecret_disabledAt$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(8);
}
function PasswordSecret_disabledAt$_get_annotations_$ref_r0tccb() {
  return (p0) => p0.bz();
}
var PasswordSecret_disabledAtClass;
function PasswordSecret_disabledAt() {
  if (PasswordSecret_disabledAtClass === VOID) {
    class $ {
      constructor() {
        PasswordSecret_disabledAt_instance = this;
        var tmp = this;
        tmp.z2v_1 = lazy(PasswordSecret_disabledAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a2w_1 = lazy(PasswordSecret_disabledAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b2w_1 = lazy(PasswordSecret_disabledAt$annotations$delegate$lambda);
        this.c2w_1 = null;
        this.d2w_1 = 'null';
      }
      i20() {
        var tmp0 = this.z2v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PasswordSecret_disabledAt$_get_name_$ref_rsoads(), null);
        return tmp0.f2();
      }
      g2u(receiver) {
        return receiver.p2u_1;
      }
      k2j(receiver) {
        return this.g2u(receiver instanceof PasswordSecret() ? receiver : THROW_CCE());
      }
      t2v(receiver, value) {
        return receiver.r2u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PasswordSecret() ? receiver : THROW_CCE();
        return this.t2v(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PasswordSecret_disabledAt$_get_serializer_$ref_gxthg7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b2w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PasswordSecret_disabledAt$_get_annotations_$ref_r0tccb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PasswordSecret_disabledAt', VOID, VOID, [SerializableProperty()]);
    PasswordSecret_disabledAtClass = $;
  }
  return PasswordSecret_disabledAtClass;
}
var PasswordSecret_disabledAt_instance;
function PasswordSecret_disabledAt_getInstance() {
  if (PasswordSecret_disabledAt_instance === VOID)
    new (PasswordSecret_disabledAt())();
  return PasswordSecret_disabledAt_instance;
}
//region block: exports
export {
  preparePasswordSecretFields as preparePasswordSecretFields123t1fj46m6bp,
};
//endregion

//# sourceMappingURL=PasswordSecretFields.mjs.map
